import mobileClocks from "./mobileclocks/store";
import overtime from "./overtime/store";

export default {
  namespaced: true,
  modules: {
    mobileClocks,
    overtime,
  },
};
